"use strict";
/**
 * R10 (addendum §3): the Debt Eliminator design's words (Plan Page ·
 * DebtEliminator.dc.html), for the page with the redesign switch on, on both apps
 * (rule 17). Every figure comes from `/api/plan/debt/` (Plan's engine); helpers take
 * preformatted money and dates ("$300", "Dec 2028"), as Plan's copy does.
 *
 * C1 (Paul's default): the page title is "Debt Eliminator" with the kicker "Plan", and
 * its bucket sentences say "Debt payoff bucket" (the board says "Debt Eliminator bucket").
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBT_ADD_BY_HAND_COPY = exports.DEBT_MISSING_ONE_COPY = exports.DEBT_ADD_BALANCE_COPY = exports.DEBT_ADD_BALANCE_NOTE_COPY = exports.DEBT_ADD_TO_PLAN_COPY = exports.DEBT_NOT_A_DEBT_CONFIRM_BODY_COPY = exports.DEBT_NOT_A_DEBT_CONFIRM_TITLE_COPY = exports.DEBT_REMOVE_DEBT_COPY = exports.DEBT_TAKE_OUT_OF_PLAN_COPY = exports.DEBT_EDIT_DEBT_COPY = exports.DEBT_NOT_A_DEBT_COPY = exports.DEBT_MORE_ANSWERS_COPY = exports.DEBT_PAID_OFF_ANSWER_COPY = exports.DEBT_STILL_OWE_IT_COPY = exports.DEBT_FOUND_STATUS_COPY = exports.DEBT_FOUND_NEED_A_LOOK_COPY = exports.DEBT_FOUND_CONFIRM_COPY = exports.DEBT_FOUND_HEADING_COPY = exports.DEBT_CHART_MINIMUMS_COPY = exports.DEBT_CHART_PLAN_COPY = exports.DEBT_CHART_HEADING_COPY = exports.DEBT_MINIMUM_BOX_BODY_COPY = exports.DEBT_MINIMUM_BOX_TITLE_COPY = exports.DEBT_NEXT_TAG_COPY = exports.DEBT_LIST_ROLL_NOTE_COPY = exports.DEBT_LIST_HEADING_COPY = exports.DEBT_EXTRA_SHARED_NOTE_COPY = exports.DEBT_EXTRA_HEADING_COPY = exports.DEBT_EXTRA_UNIT_COPY = exports.DEBT_ORDER_SAVES_COPY = exports.DEBT_ORDER_OPTIONS_COPY = exports.DEBT_ORDER_HEADING_COPY = exports.DEBT_VS_MINIMUMS_COPY = exports.DEBT_INTEREST_SAVED_COPY = exports.DEBT_EXTRA_FROM_BUCKET_COPY = exports.DEBT_EXTRA_EACH_PAYDAY_COPY = exports.DEBT_IN_YOUR_PLAN_COPY = exports.DEBT_FREE_BY_COPY = exports.DEBT_PAYOFF_PLAN_LABEL_COPY = exports.DEBT_ELIMINATOR_HOW_IT_WORKS_COPY = exports.DEBT_ELIMINATOR_SUBTITLE_COPY = exports.DEBT_ELIMINATOR_TITLE_COPY = exports.DEBT_ELIMINATOR_KICKER_COPY = void 0;
exports.debtMinimumsOnlyDateCopy = debtMinimumsOnlyDateCopy;
exports.debtCountCopy = debtCountCopy;
exports.debtFirstPaidOffCopy = debtFirstPaidOffCopy;
exports.debtSoonerCopy = debtSoonerCopy;
exports.debtExtraNoteCopy = debtExtraNoteCopy;
exports.debtPayingFirstTagCopy = debtPayingFirstTagCopy;
exports.debtRowMetaCopy = debtRowMetaCopy;
exports.debtPaidOffOnCopy = debtPaidOffOnCopy;
exports.debtChartEndCopy = debtChartEndCopy;
exports.debtChartLabelCopy = debtChartLabelCopy;
exports.debtFoundLineCopy = debtFoundLineCopy;
exports.debtFoundMetaCopy = debtFoundMetaCopy;
exports.debtStoppedQuestionCopy = debtStoppedQuestionCopy;
exports.debtTrackedMetaCopy = debtTrackedMetaCopy;
exports.DEBT_ELIMINATOR_KICKER_COPY = "Plan";
exports.DEBT_ELIMINATOR_TITLE_COPY = "Debt Eliminator";
exports.DEBT_ELIMINATOR_SUBTITLE_COPY = "Built from your 12-month analysis. Pick an order, set your extra, see your debt-free date.";
exports.DEBT_ELIMINATOR_HOW_IT_WORKS_COPY = "How Debt Eliminator works";
/** "Your payoff plan": the four tiles. */
exports.DEBT_PAYOFF_PLAN_LABEL_COPY = "Your payoff plan";
exports.DEBT_FREE_BY_COPY = "Debt-free by";
exports.DEBT_IN_YOUR_PLAN_COPY = "In your plan";
exports.DEBT_EXTRA_EACH_PAYDAY_COPY = "Extra each payday";
exports.DEBT_EXTRA_FROM_BUCKET_COPY = "from your Debt Eliminator bucket";
exports.DEBT_INTEREST_SAVED_COPY = "Interest saved";
exports.DEBT_VS_MINIMUMS_COPY = "vs. minimums only";
/** "Minimums only: Jul 2030" */
function debtMinimumsOnlyDateCopy(date) {
    return `Minimums only: ${date}`;
}
/** "4 debts", "1 debt" */
function debtCountCopy(n) {
    return `${n} ${n === 1 ? "debt" : "debts"}`;
}
/** "Pay down in this order": the two cards of the radiogroup. */
exports.DEBT_ORDER_HEADING_COPY = "Pay down in this order";
exports.DEBT_ORDER_OPTIONS_COPY = {
    avalanche: {
        label: "Highest rate first",
        description: "Saves the most interest",
    },
    snowball: {
        label: "Smallest balance first",
        description: "Quickest first win",
    },
};
/** Before the amount, which is bold: "Saves **$2,773**". */
exports.DEBT_ORDER_SAVES_COPY = "Saves";
/** "First one paid off Mar 2027" */
function debtFirstPaidOffCopy(date) {
    return `First one paid off ${date}`;
}
/** DE 1.3 §4.5: the extra's editor is Plan's (− / +, a typed amount, $ / %), labelled
 *  "each payday". The board's $150 · $300 · $450 presets are gone. */
exports.DEBT_EXTRA_UNIT_COPY = "each payday";
exports.DEBT_EXTRA_HEADING_COPY = exports.DEBT_EXTRA_EACH_PAYDAY_COPY;
exports.DEBT_EXTRA_SHARED_NOTE_COPY = "This is your Debt Eliminator bucket on Plan. Changing it here changes it there, and Home updates right away.";
/** "1 year", "1 year and 7 months", "2 years", "7 months" (the note's gap). */
function debtSoonerCopy(months) {
    const years = Math.floor(months / 12);
    const rest = months % 12;
    const y = years > 0 ? `${years} ${years === 1 ? "year" : "years"}` : "";
    const m = rest > 0 ? `${rest} ${rest === 1 ? "month" : "months"}` : "";
    return y && m ? `${y} and ${m}` : y || m;
}
/**
 * "$300 each payday is about $650 a month on top of your minimums. You’re debt-free Dec
 * 2028, 1 year and 7 months sooner than with minimums only." The second sentence needs a
 * debt-free date, and its gap only when the plan is sooner than minimums only.
 */
function debtExtraNoteCopy(p) {
    const first = `${p.extra} each payday is about ${p.monthly} a month on top of your minimums.`;
    if (p.debtFree === null)
        return first;
    if (p.monthsSooner === null || p.monthsSooner <= 0) {
        return `${first} You’re debt-free ${p.debtFree}.`;
    }
    return `${first} You’re debt-free ${p.debtFree}, ${debtSoonerCopy(p.monthsSooner)} sooner than with minimums only.`;
}
/** "Your debts, in payoff order". */
exports.DEBT_LIST_HEADING_COPY = "Your debts, in payoff order";
exports.DEBT_LIST_ROLL_NOTE_COPY = "When one is paid off, its minimum and extra roll to the next.";
exports.DEBT_NEXT_TAG_COPY = "Next";
/** 1.3 §4.6: the minimum-payment callout above the list (always shown, not dismissable). */
exports.DEBT_MINIMUM_BOX_TITLE_COPY = "Keep paying the minimum on every debt.";
exports.DEBT_MINIMUM_BOX_BODY_COPY = "Only the debt being paid first gets your extra. Every other debt still needs its minimum payment each month. Missing one can mean late fees, a higher rate and a hit to your credit, and it pushes back your debt-free date.";
/** "Paying first · min + $300 extra" */
function debtPayingFirstTagCopy(extra) {
    return `Paying first · min + ${extra} extra`;
}
/** "27.9% APR · minimum $145" */
function debtRowMetaCopy(apr, minimum) {
    return `${apr} APR · minimum ${minimum}`;
}
/** "Paid off Mar 2027" */
function debtPaidOffOnCopy(date) {
    return `Paid off ${date}`;
}
/** "Your balance over time". */
exports.DEBT_CHART_HEADING_COPY = "Your balance over time";
exports.DEBT_CHART_PLAN_COPY = "Your plan";
exports.DEBT_CHART_MINIMUMS_COPY = "Minimums only";
/** "Debt-free Dec 2028", the label at the end of the plan's line. */
function debtChartEndCopy(date) {
    return `Debt-free ${date}`;
}
/** The chart's `aria-label`: "Total debt falls from $39,130 to $0 by Dec 2028 with your
 *  plan, versus Jul 2030 with minimums only." */
function debtChartLabelCopy(total, debtFree, minimumsFree) {
    return `Total debt falls from ${total} to $0 by ${debtFree} with your plan, versus ${minimumsFree} with minimums only.`;
}
/** Anthony, 2 Nov (verbatim): the debts the analysis found are suggestions. */
exports.DEBT_FOUND_HEADING_COPY = "We found these possible debts, confirm to add them";
/** A found payment not added yet: its button (Paul, 3 Nov). Opens the confirm form. */
exports.DEBT_FOUND_CONFIRM_COPY = "Confirm to add";
/** No debt confirmed yet while suggestions wait: never "you have no debt" (Anthony, 2 Nov;
 *  the line decided by Paul, 3 Nov). */
exports.DEBT_FOUND_NEED_A_LOOK_COPY = "We found possible debts that need a look.";
/** "5 regular payments looked like debts · 4 in your plan · 1 needs an answer" */
function debtFoundLineCopy(lookedLike, inPlan, needsAnswer, tracked = 0) {
    const looked = lookedLike === 1
        ? "1 regular payment looked like a debt"
        : `${lookedLike} regular payments looked like debts`;
    // With nothing waiting for an answer the clause goes (ours, agreed with mobile); "0 in
    // your plan" stays, since it says something.
    // Debt Eliminator 1.3 §4.3: "· 1 tracked as a bill" (the mortgage), dropped at 0 like
    // the answer clause.
    const parts = [looked, `${inPlan} in your plan`];
    if (tracked > 0)
        parts.push(`${tracked} tracked as a bill`);
    if (needsAnswer > 0)
        parts.push(`${needsAnswer} ${needsAnswer === 1 ? "needs" : "need"} an answer`);
    return parts.join(" · ");
}
exports.DEBT_FOUND_STATUS_COPY = {
    in_plan: "In plan",
    check: "Check",
    tracked: "Tracked",
};
/** "Credit card · $145 a month" */
function debtFoundMetaCopy(who, monthly) {
    return `${who} · ${monthly} a month`;
}
/** "No payment since Mar 22. Do you still owe it?" */
function debtStoppedQuestionCopy(date) {
    return `No payment since ${date}. Do you still owe it?`;
}
exports.DEBT_STILL_OWE_IT_COPY = "Still owe it";
exports.DEBT_PAID_OFF_ANSWER_COPY = "Paid off";
exports.DEBT_MORE_ANSWERS_COPY = "More…";
/** 1.3 §4.3: "More…" on a debt with no payment in 60 days: Not a debt, Edit. */
exports.DEBT_NOT_A_DEBT_COPY = "Not a debt";
exports.DEBT_EDIT_DEBT_COPY = "Edit";
/** Kept until mobile switches to Not a debt (confirm) / Edit (#2246 uses them); web no
 *  longer does. Deleted in a later small PR. */
exports.DEBT_TAKE_OUT_OF_PLAN_COPY = "Take it out of the plan";
exports.DEBT_REMOVE_DEBT_COPY = "Remove this debt";
/** Ours (flagged for Anthony): Not a debt on an added debt asks first; it has no undo. */
exports.DEBT_NOT_A_DEBT_CONFIRM_TITLE_COPY = "Not a debt?";
exports.DEBT_NOT_A_DEBT_CONFIRM_BODY_COPY = "It comes out of your plan and won't be suggested again.";
/** "$2,850 a month · a bill, not in the payoff plan" */
function debtTrackedMetaCopy(monthly) {
    return `${monthly} a month · a bill, not in the payoff plan`;
}
exports.DEBT_ADD_TO_PLAN_COPY = "Add to plan";
/** Ours (the board assumes every balance is known): a card or loan found in checking,
 *  in the plan by default, whose balance and rate aren't known yet. */
exports.DEBT_ADD_BALANCE_NOTE_COPY = "Add its balance and rate to put it in your payoff order.";
exports.DEBT_ADD_BALANCE_COPY = "Add balance";
/** "Missing one? Add a debt by hand" (the link is the second part). */
exports.DEBT_MISSING_ONE_COPY = "Missing one?";
exports.DEBT_ADD_BY_HAND_COPY = "Add a debt by hand";
//# sourceMappingURL=debtEliminatorPageCopy.js.map